// extracted by mini-css-extract-plugin
export default {"cls1":"PingAnswerStyles-cls1___a842d43d82553c7fdef","cls2":"PingAnswerStyles-cls2___68546b3f0a774aef6a3 PingAnswerStyles-cls1___a842d43d82553c7fdef"};